<template>
  <div class="row row-line-item" v-if="costingline">
    <div class="col-5 line-heading">
      <div class="row">
        <div class="col-1">
          <i class="fa fa-grip-lines float-left drag drag_handle"></i>
        </div>
        <div class="col-4">
          <input
            type="text"
            v-model="stateTitle"
            @blur="handleUpdateUserStory"
            class="form-control text-start"
            :disabled="isDisabled"
          />
        </div>
        <div class="col-7">
          <textarea
            style="overflow: hidden;"
            type="text"
            v-model="stateDescription"
            @blur="handleUpdateUserStory"
            class="form-control text-start"
            :disabled="isDisabled"
          ></textarea>
        </div>
      </div>
    </div>
    <div class="col flex-cell">
      <input type="checkbox" v-model="stateDisplay" @blur="handleUpdateUserStory" :disabled="isDisabled" />
    </div>
    <div class="col flex-cell">
      <input
        type="text"
        @blur="handleUpdateUserStory"
        v-model="stateEstimate"
        class="form-control text-start"
        :disabled="isDisabled"
      />
    </div>
    <div class="col flex-cell"></div>
    <div class="col flex-cell cost">
      <div class="w-100 text-end">${{ costingline.total_ex | currency }}</div>
    </div>
    <div class="col-1 options">
      <div class="dropdown" v-if="!isSigned">
        <button
          type="button"
          id="dropdownMenu1"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="true"
          class="btn btn-light"
        >
          <i class="fa fa-ellipsis-h"></i>
        </button>
        <div aria-labelledby="dropdownMenu1" class="dropdown-menu">
          <a href="#" class="dropdown-item" @click="confirmDelete">Delete</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { notify, http } from 'utils'
import { SET_SAVE_STATUS } from 'vx/mutations'
import { WysiwygInline } from 'components/form/input'
import { stateMapper } from 'mixins/user-stories'
import AppConstants from '@/support/app-constants'
import { debounce, clone, findIndex } from 'lodash'
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
import { isEqual, find, each, isNaN, toNumber, cloneDeep, filter, map, intersectionBy } from 'lodash'

var Story = require('./../../../models/story.js')

export default {
  mixins: [stateMapper],

  components: {
    WysiwygInline,
  },

  props: ['userstory', 'epic', 'parentOrder', 'epicIndex', 'storyIndex', 'costingline'],

  data: function() {
    return {
      dirty: false,
      focus: false,
    }
  },

  computed: {
    ...mapState('project', ['project']),
    ...mapState('settings/app', ['save_status']),
    ...mapState('epics', ['epics']),
    ...mapState('costing', ['lines']),
    ...mapState('opportunity', {
      opportunity: 'single',
    }),
    ...mapGetters('costing', ['getLineByStoryId']),
    ...mapGetters('opportunity', ['isSigned']),

    order() {
      return this.storyIndex + 1
    },

    isDisabled() {
      return this.isSigned || this.opportunity.approved_at != null
    },
  },

  methods: {
    ...mapMutations('settings/app', [SET_SAVE_STATUS]),
    ...mapActions('epics', ['addUserStory', 'updateUserStory', 'deleteUserStory']),

    confirmDelete() {
      this.$swal({
        title: 'Confirm Delete',
        html: `Are you sure you want to delete US #${this.parentOrder}.${this.order} <br> this will reset this epics ordering.`,
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Delete',
      }).then(() => {
        this.handleDeleteUserStory()
      })
    },

    handleDeleteUserStory() {
      var that = this
      var userstory = clone(this.userstory)
      this[SET_SAVE_STATUS](AppConstants.save_status.SAVING)

      return this.deleteUserStory({
        docId: this.epic.user_story_document_id,
        userstory: this.userstory,
      })
        .then(response => {
          //Send broadcast to send re-order so the api will reorder and return a fresh userstory list with updated indexes
          this.$bus.$emit('delete-user-story', userstory.epic_id)
          this[SET_SAVE_STATUS](AppConstants.save_status.SAVED)
        })
        .catch(error => {
          if (error.response.status.code == 422) {
            var firstValidationIssue = error.response.data.errors[Object.keys(error.response.data.errors)[0]]

            notify.error(firstValidationIssue)
            this[SET_SAVE_STATUS](AppConstants.save_status.UNSAVED)
          } else if (error.response.status === 400) {
            notify.error(error.response.data.message)
          } else {
            notify.error('An unexpected error occured!')
            this[SET_SAVE_STATUS](AppConstants.save_status.ERROR_SAVING)
          }
        })
    },

    handleUpdateUserStory() {
      var that = this
      this[SET_SAVE_STATUS](AppConstants.save_status.SAVING)

      return this.updateUserStory({
        docId: this.epic.user_story_document_id,
        storyId: this.userstory.id,
        payload: this.userstory,
      })
        .then(response => {
          this.dirty = false
          this[SET_SAVE_STATUS](AppConstants.save_status.SAVED)

          this.$bus.$emit('updateCosting')
        })
        .catch(error => {
          if (error.response.status === 422) {
            notify.error(error.response.data.errors[Object.keys(error.response.data.errors)[0]])
          } else if (error.response.status === 400) {
            notify.error(error.response.data.message)
          }
        })
    },
    saveUserstoryDescription(data) {
      // return client({path: '/user-story-document/'+this.project.user_story_document_id +'/stories/'+this.userstory.id, entity: {title: this.userstory.title, order: this.userstory.order, description: data}, method: 'PUT'})
      //Would use this but it breaks the ordering of userstories the after saved then move userstory twice
      return this.updateUserStory({
        docId: this.epic.user_story_document_id,
        storyId: this.userstory.id,
        payload: { title: this.userstory.title, order: this.userstory.order, description: data },
      })
    },
    blur() {
      this.focus = false
    },
  },
}
</script>

<style scoped>
.line-heading .ck-content {
  color: #838593;
  font-size: 14px;
}

.form-control {
  padding-left: 0px;
}
</style>
